<template>
  <div
    class="v-avatar__outer"
    :class="{ ['clickable']: !!clickable, ['active']: isActive }"
  >
    <div
      class="v-avatar__wrapper"
      :class="{ ['use-initials']: useInitials }"
      :style="{
        width: width,
        height: height,
        maxWidth: width,
        backgroundColor: _bgColor,
        fontSize: useInitials ? fontSize : 'inherit',
      }"
      @click="$emit('click')"
    >
      <span v-if="useInitials"> {{ getLogoLetters() }} </span>
      <img v-else :src="image" alt="avatar" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import sample from "lodash/sample";
import {isStringContainsEmoji} from "@/utils/util"

const ITEMS_PALETTE = [
  "#5757F5",
  "#A8A8FF",
  "#5C5CFF",
  "#545480",
  "#4949CC",
  "#FFCB4C",
  "#FFA34D",
  "#CCA43D",
  "#29CC94",
  "#408069",
  "#FF5C4A",
  "#FFA196",
  "#CC4A3B",
];

export default Vue.component("VAvatar", {
  props: {
    // to display first, last name
    // instead of image
    useInitials: VueTypes.bool.def(true),

    firstName: VueTypes.string,
    lastName: VueTypes.string,
    image: VueTypes.string,

    width: VueTypes.string.def("72px"),
    height: VueTypes.string.def("72px"),
    bgColor: VueTypes.string,
    fontSize: VueTypes.string.def("16px"),
    useColorFromPalette: VueTypes.bool.def(false),
    clickable: VueTypes.bool.def(true),
    isActive: VueTypes.bool.def(false),
    colorsPalette: VueTypes.arrayOf(VueTypes.string).def(ITEMS_PALETTE),
  },

  methods: {
    getSrc() {
      return this.useInitials ? this.getLogoLetters() : this.image;
    },

    getLogoLetters() {
      const firstName = !this.firstName
        ? ""
        : isStringContainsEmoji(this.firstName.slice(0, 2))
        ? this.firstName.slice(0, 2)
        : this.firstName[0].toUpperCase();

      const lasttName = !this.lastName
        ? ""
        : isStringContainsEmoji(this.lastName.slice(0, 2))
        ? this.lastName.slice(0, 2)
        : this.lastName[0].toUpperCase();

      return firstName+lasttName;
    },
  },

  computed: {
    _bgColor() {
      if (this.useInitials) {
        return !!this.bgColor
          ? this.bgColor
          : this.useColorFromPalette
          ? this._paletteColor
          : this.bgColor;
      }

      return this.bgColor ? this.bgColor : "transparent";
    },

    _paletteColor() {
      return sample(this.colorsPalette);
    },
  },
});
</script>

<style lang="scss" scoped>
$ns: "v-avatar";

.#{$ns} {
  &__wrapper {
    color: $white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 0 auto;
    border-radius: 50%;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }

  &__outer {
    border: 1px solid transparent;

    &.clickable {
      &.active,
      &:hover {
        border-radius: 50%;
        border-color: $primary-color;
      }
    }
  }
}
</style>
